import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicSafety/img/1.avif';
import function1 from '@src/assets/images/solution/publicSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/publicSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/publicSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/publicSafety/img/function4.avif';
import image3 from '@src/assets/images/solution/publicSafety/img/3.avif';
import image4 from '@src/assets/images/solution/publicSafety/img/4.avif';
import image5 from '@src/assets/images/solution/publicSafety/img/5.avif';
import image6 from '@src/assets/images/solution/publicSafety/img/6.avif';
import image7 from '@src/assets/images/solution/publicSafety/img/7.avif';
import image8 from '@src/assets/images/solution/publicSafety/img/8.avif';
import image9 from '@src/assets/images/solution/publicSafety/img/9.avif';
import image10 from '@src/assets/images/solution/publicSafety/img/10.avif';

import customer1 from '@src/assets/images/solution/publicSafety/img/customer1.png';
import { publicSafety1, publicSafety2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '城市安全解决方案',

  recommend: {
    title: '',
    desc: 'ORBRO OS 是一款强大的实时定位追踪与智能监控平台。<br/>它完美融合了 BLE、UWB 与 AI 视频分析技术，专为提升公共环境的安全性、效率与扩展性而设计。',
    labels: {
      desktop: [
        { img: publicSafety1, data: recommendation.loraGateway },
        { img: publicSafety2, data: recommendation.safetyBell },
      ],
      mobile: [{ data: recommendation.safetyBell }, { data: recommendation.loraGateway }, { data: recommendation.server }],
    },
  },

  banner: {
    title: '一键实时守护整个城市',
    desc: '通过部署公共安全铃，构建城市级应急基础设施，实时保护市民安全。',
  },

  summary: {
    title: '构建可一览全局的城市监控系统。',
    desc: '',
    function: {
      card: [
        {
          image: function1,
          title: '实时运营指标仪表盘',
          desc: '可实时汇总通报数量、申请数量、使用率、年龄和地域分布等核心指标，为城市级决策提供支持。',
        },
        {
          image: function2,
          title: '按申请类型分析需求趋势',
          desc: '按日跟踪家庭、商铺、公共设施等申请类型，精确定位高峰期，为策略部署提供决策依据。',
        },
        {
          image: function3,
          title: '基于区域数据制定空间策略',
          desc: '细分展示各区域的申请数、注册数、实际通报数，帮助评估区域风险与资源配置优先级。',
        },
        {
          image: function4,
          title: '申请至安装全过程可追溯',
          desc: '系统记录从申请、配送、接收、安装的各环节，确保流程透明、避免遗漏与延误。',
        },
      ],
    },
  },

  numOfCard: {
    title: '真实运行指标，数据见证效果',
    desc: '从申请到安装、通报全过程，展示系统在实践中的表现。',
    card: [
      {
        tag: '21,480 人',
        title: '累计申请数',
        desc: '自部署“安全铃”以来的总申请人数',
      },
      {
        tag: '96.7%',
        title: '注册完成率',
        desc: '设备领取后完成 App 注册的用户比例',
      },
      {
        tag: '62%',
        title: '定期测试按钮使用率',
        desc: '每季度至少使用一次测试按钮的比例',
      },
    ],
  },

  func: [
    {
      theme: '小巧却智能的应急呼叫设备。',
      title: '一键即发紧急呼叫',
      desc: '按下按钮即可自动拨打 112，并向家属或亲友发送短信提醒，紧急情况下无需智能手机也能及时响应。',
      sub1: '高响应可靠性',
      icon1: IconRulerGray,
      sub2: '实时状态反馈',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: '可安装于墙面、柱子、门口等多种场景',
      desc: '设备设计用于快速固定，无需电源支持，满足室内外多种环境安装需求。',
      sub2: '实时定位追踪',
      icon1: IconBinocularsGray,
      sub1: '高速数据同步',
      icon2: IconTvocGray,
      image: image4,
    },
    {
      title: '内置测试按钮，随时自检',
      desc: '可随时按下测试按钮，检查设备状态，确保功能正常，运维更安心。',
      sub1: '实时定位追踪',
      icon1: IconBinocularsGray,
      sub2: '高响应可靠性',
      icon2: IconRulerGray,
      image: image5,
    },
    {
      title: '超低功耗设计，最长可用 10+ 年',
      desc: '无需频繁更换电池，支持长期稳定运行。',
      sub1: '灵活分区配置',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      image: image6,
    },
    {
      theme: '借助 App 提升运维效率与响应速度。',
      title: '实时查看与取消报警请求',
      desc: 'App 可查看报警是否已被接收，并支持 2 分钟内取消误报警。',
      sub1: '灵活分区配置',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: '自由设置通知接收者',
      desc: '可同时通知 112、家属及相关人员，实现个人与社会联动。',
      sub1: '灵活分区配置',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      image: image8,
    },
    {
      title: '完整通知记录统一管理',
      desc: '汇总记录警报触发、取消、测试、低电、换件请求等，便于溯源与维护。',
      sub1: '灵活分区配置',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      image: image9,
    },
    {
      title: '远程固件升级功能',
      desc: '通过 App 远程更新固件，无需现场操作设备，简化运维流程。',
      sub1: '灵活分区配置',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      image: image10,
    },
  ],

  customer: {
    title: '众多客户选择 ORBRO 的理由',
    card: [
      {
        logo: customer1,
        desc: '“部署后能实时查看设备在何处、由谁以何种方式使用，非常关键。不仅是发设备，更能帮助决策下阶段重点布点。”',
        name: '郑O勇 本部长<br/>京畿道厅',
      },
    ],
  },

  subfunc: {
    title: '功能总结',
    desc: '保障安全提升效率、降低损失。ORBRO 提供应对危险区域与设备使用场景的定制化功能。',
    data: [
      {
        icon: IconLocation,
        title: '112 紧急呼叫联动',
        desc: '一键按下即拨打 112，并发送短信给家属。',
      },
      {
        icon: IconLocation,
        title: '多对象通知设置',
        desc: '可同时设置通知到 112、家人、朋友等多个接收方。',
      },
      {
        icon: IconAnalytics,
        title: '取消报警功能',
        desc: '误报可在 2 分钟内 App 取消，防止误警。',
      },
      {
        icon: IconSearch,
        title: '远程固件更新',
        desc: '通过 App 安全更新固件，无需现场维护。',
      },
      {
        icon: IconChartBar,
        title: '实时电量监控',
        desc: 'App 可实时查询电池与电源状态。',
      },
      {
        icon: IconLayers,
        title: '超低功耗长寿命设计',
        desc: '10 年以上无需更换电池。',
      },
      {
        icon: IconSearch,
        title: '现场测试按钮',
        desc: '安装后可手动测试设备是否正常。',
      },
      {
        icon: IconLayers,
        title: '固定安装结构',
        desc: '可牢固安装在墙面或柱子上，避免移动和误用。',
      },
      {
        icon: IconAnalytics,
        title: '数据驱动运维策略',
        desc: '通过数据分析优化设备布点与管理策略。',
      },
      {
        icon: IconChartBar,
        title: '区域/时段统计分析',
        desc: '提供基于区域、类型和时间的统计报表。',
      },
    ],
  },

  system: {
    title: '系统配置',
    img: rtlsSystem,
  },

  productTitle: '产品阵容',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
